import { render, staticRenderFns } from "./externalAddress.vue?vue&type=template&id=74e4d074&scoped=true&"
import script from "./externalAddress.vue?vue&type=script&lang=js&"
export * from "./externalAddress.vue?vue&type=script&lang=js&"
import style0 from "./externalAddress.vue?vue&type=style&index=0&id=74e4d074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e4d074",
  null
  
)

export default component.exports